import type { OpenClawPluginApi } from 'openclaw/plugin-sdk/core';
import { emptyPluginConfigSchema } from 'openclaw/plugin-sdk/core';
import { registerTuiTuiChannel } from './src/channel';
import { registerTuituiTools } from './src/tools';
import { registerMonitorHooks } from './src/monitor';
import { CHANNEL_ID, CHANNEL_NAME } from './src/const';
import { id } from './openclaw.plugin.json';

const plugin = {
  id, // plugin id not is CHANNEL_ID
  name: CHANNEL_NAME,
  description: `${CHANNEL_NAME} chat integration for OpenClaw via WebSocket`,
  configSchema: emptyPluginConfigSchema(),
  register(api: OpenClawPluginApi) {
    registerTuiTuiChannel(api);
    registerTuituiTools(api);
    registerMonitorHooks(api);
  },
};
console.log(`[${CHANNEL_ID}] Tuitui Extension Loaded!`);
export default plugin;
